// extracted by mini-css-extract-plugin
module.exports = {"sun":"styles_sun____4Gb","loading-wheel":"styles_loading-wheel__QO0Um"};